import { render, staticRenderFns } from "./InfoEmployee.vue?vue&type=template&id=6cf8f6ef&scoped=true"
import script from "./InfoEmployee.vue?vue&type=script&lang=js"
export * from "./InfoEmployee.vue?vue&type=script&lang=js"
import style0 from "./InfoEmployee.vue?vue&type=style&index=0&id=6cf8f6ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8f6ef",
  null
  
)

export default component.exports